// extracted by mini-css-extract-plugin
module.exports = {"helpInfo":"HelpInfo_helpInfo__1qGzn","helpInfoLogo":"HelpInfo_helpInfoLogo__id6Pm","linkWhatsapp":"HelpInfo_linkWhatsapp__2Hg5F","regularText":"HelpInfo_regularText__2eWXV"};